// src/utils/eventBus.js
import mitt from 'mitt';

// 创建全局事件总线实例
const emitter = mitt();

export default emitter;
